import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'pane']

  select(event) {
    event.preventDefault()
    event.stopPropagation()

    const tab = event.currentTarget
    const targetSelector = tab.dataset.bsTarget
    const pane = this.paneTargets.find(candidate => `#${candidate.id}` === targetSelector)
    if (!pane) return

    this.tabTargets.forEach(otherTab => {
      const isSelected = otherTab === tab
      otherTab.classList.toggle('active', isSelected)
      otherTab.setAttribute('aria-selected', isSelected ? 'true' : 'false')
      otherTab.closest('.nav-item')?.classList.toggle('active', isSelected)
    })

    this.paneTargets.forEach(otherPane => {
      const isSelected = otherPane === pane
      otherPane.classList.toggle('active', isSelected)
      otherPane.classList.toggle('show', isSelected)
      otherPane.classList.toggle('in', isSelected)
    })
  }
}
